import * as React from "react";
import { DatePicker } from "office-ui-fabric-react/lib/DatePicker";

interface IMyDatePickerProps {
    id: string;
    labelText: string;
    gridArea: string;
    isVisible: boolean;
    isRequired: boolean;
    onChange: (value: any) => void;
    submitClicked: boolean;
}

export function MyDatePicker(props: IMyDatePickerProps) {

    const { id, labelText, gridArea, isVisible, isRequired, onChange, submitClicked } = props;
    const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);

    const formatDate = (date: Date) => {
        const month = date.getMonth();
        const day = date.getDate();
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    const showErrorClass = () => {
        if (submitClicked && !selectedDate && isRequired) return "ms-DatePicker__error";
        return "";
    };

    const onDateChange = (date: Date) => {
        setSelectedDate(date);
        onChange({ [id]: date });
    };

    return (
        <DatePicker
            value={selectedDate}
            label={labelText}
            isRequired={isRequired}
            aria-required={isRequired}
            onSelectDate={onDateChange}
            className={`ms-Custom-Field ${!isVisible && 'ms-Hidden-Field'}`}
            styles={{
                root: { gridColumn: gridArea, gridRow: gridArea },
                wrapper: showErrorClass()
            }}
            calloutProps={{
                styles: { calloutMain: "ms-Custom-Callout__width" }
            }}
            formatDate={(date) => formatDate(date)}
        />
    );
}
